import "./App.css";
import Header from "./components/Header";

function App() {
  return (
 <div>

   <Header/>

 </div>
   
  );
}

export default App;
